import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuestionUpdateService {
  private resetQuestions = new Subject<void>();
  resetQuestions$ = this.resetQuestions.asObservable();

  notifyQuestionsReset() {
    this.resetQuestions.next();
  }
}
